import { TceSummaryService } from 'data/services';
import {
  makeSummaryOfTerminationTerms,
  makeTceSummaryBySituation,
} from 'main/factories/usecases/tce-summary';
import { makeTceManagement } from 'main/factories/usecases/tce-management';

export const makeTceSummaryService = () => {
  return new TceSummaryService(
    makeSummaryOfTerminationTerms(),
    makeTceSummaryBySituation(),
    makeTceManagement(),
  );
};
